import { useState } from "react";
import NavBar from "../../../components/navbar/NavBar";

const HelpSection = () => {
  const [isOpen, setIsOpen] = useState(false);

  return(
    <>
      <NavBar />
      <div className={`sidebar-sec ${isOpen ? "active" : ""}`}>
        <section id="content-wrapper">
          <div className="video-container">
          <iframe width="100%" height="750" src="https://www.youtube.com/embed/7V_Phj2Ndb4?si=ikAAN6MAZZLj1XiM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </section>
      </div>
    </>
  );
};

export default HelpSection;
